import React from 'react';
import PropTypes from 'prop-types';
import OfficePageContentMain from './OfficePageContentMain';
import OfficePageContentExtra from './OfficePageContentExtra';
import { separateByOfficeType } from 'redux/models/offices/model';
import { ParamsContext } from 'components/Context/ParamsContext';
import { PARAM_OFFICE_SELECTED } from 'config/params';
import isEmpty from 'lodash/isEmpty';

const OfficePageContent = ({ offices }) => {
  const { [PARAM_OFFICE_SELECTED]: selectedOffice } = React.useContext(ParamsContext);
  const [mainOffices, extraOffices] = React.useMemo(() => separateByOfficeType(offices), [offices]);

  return (
    <>
      {!isEmpty(mainOffices) && (
        <OfficePageContentMain
          selectedOffice={selectedOffice}
          offices={mainOffices}
        />
      )}
      {!isEmpty(extraOffices) && (
        <OfficePageContentExtra
          selectedOffice={selectedOffice}
          offices={extraOffices}
        />
      )}
    </>
  );
};

OfficePageContent.propTypes = {
  offices: PropTypes.array
};

export default OfficePageContent;
